export default __webpack_public_path__ + "static/media/paging_last_disabled.5f18c2bf.svg";